<mat-form-field class="w-100" appearance="outline">
  <mat-label>
    {{ placeholder }}
  </mat-label>
  <input
    matInput
    [formControl]="control"
    [matAutocomplete]="auto"
    [type]="inputType"
    (blur)="blur.emit($event)"
    [readonly]="readonly"
    name="fast-autcomplete"
    autocomplete="off"
  />
  <button
    *ngIf="showBtnDialog"
    mat-icon-button
    matSuffix
    (click)="dialogClick()"
  >
    <mat-icon color="primary">{{ btnIcon }}</mat-icon>
  </button>
  <button
    *ngIf="!showBtnDialog && controlIsEnabled"
    mat-icon-button
    matSuffix
    (click)="control.value ? clearSelectValue() : null"
  >
    <i
      *ngIf="control.value"
      class="pi pi-times-circle mb-1"
      style="color: red"
    ></i>
    <i
      *ngIf="!control.value"
      class="pi pi-angle-down mb-1"
      style="color: 'var(--primary-color)'"
    ></i>
  </button>
</mat-form-field>
<small class="p-error" *ngIf="control.invalid && control.touched">
  {{ messages[getKey()] }}
</small>
<mat-autocomplete
  (blur)="blur.emit($event)"
  autoActiveFirstOption
  #auto="matAutocomplete"
  [displayWith]="displayWithEntityFn"
>
  <div *ngIf="!notShowOptions">
    <mat-option disabled *ngIf="isLoading" class="is-loading">
      <mat-spinner diameter="30" color="primary"></mat-spinner>
    </mat-option>
    <!-- <mat-option
      disabled
      *ngIf="
        noResults &&
        control.value &&
        !isLoading &&
        !control.hasError('isEmptyValue')
      "
    >
      Não encontramos nada com {{ control.value }}
    </mat-option> -->
    <mat-option
      disabled
      *ngIf="filteredEntities.length === 0 && !control.hasError('isEmptyValue')"
    >
      Não existe nenhum disponível!
    </mat-option>
    <ng-container *ngIf="!isLoading">
      <mat-option
        (onSelectionChange)="onSelect.emit(entity)"
        *ngFor="let entity of filteredEntities"
        [value]="entity"
      >
        {{ displayWithEntityFn(entity) }}
      </mat-option>
      <mat-option
        *ngIf="
          !isLoading &&
          insertType &&
          actionState &&
          !control.hasError('isEmptyValue')
        "
      >
        <div
          (click)="
            openDialogAddEntity ? openDialogAddEntity() : openDialogFast()
          "
          style="display: flex; align-items: center; color:#666;"
        >
          <i class="mdi mdi-plus"></i>
          Adicionar agora
        </div>
      </mat-option>
    </ng-container>
  </div>
</mat-autocomplete>
